import { render, staticRenderFns } from "./Banks.vue?vue&type=template&id=6735578f&scoped=true"
import script from "./Banks.vue?vue&type=script&lang=js"
export * from "./Banks.vue?vue&type=script&lang=js"
import style0 from "./Banks.vue?vue&type=style&index=0&id=6735578f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6735578f",
  null
  
)

export default component.exports